import React, { useMemo, useState } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const CompanyMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const [statusFilter, setStatusFilter] = useState("Y");

  const filteredMasterList = useMemo(() => {
    if (!Array.isArray(masterList)) return [];
    return masterList.filter((m) => String(m?.Comp_Status ?? "Y") === String(statusFilter));
  }, [masterList, statusFilter]);

  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "6%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Comp_Id",
        header: "รหัสบริษัท (ID)",
        width: "8%",
        align: "center",
        render: (item) => item?.Comp_Id ?? item?.Comp_id ?? "-",
      },
      {
        key: "Comp_Code",
        header: "รหัสอ้างอิงบริษัท",
        width: "14%",
        align: "center",
        render: (item) => item.Comp_Code || "-",
      },
      {
        key: "Comp_Name_TH",
        header: "ชื่อบริษัทภาษาไทย",
        width: "26%",
        align: "start",
        render: (item) => item.Comp_Name_TH || "-",
      },
      {
        key: "Comp_ShortName",
        header: "ชื่อบริษัทแบบย่อ",
        width: "18%",
        align: "start",
        render: (item) => item.Comp_ShortName || "-",
      },
      {
        key: "Comp_TaxNo",
        header: "เลขภาษี",
        width: "16%",
        align: "center",
        render: (item) => item.Comp_TaxNo || "-",
      },
      {
        key: "Comp_Tel1",
        header: "เบอร์โทร",
        width: "14%",
        align: "center",
        render: (item) => item.Comp_Tel1 || "-",
      },
      {
        key: "Comp_Status",
        header: "สถานะ",
        width: "8%",
        align: "center",
        render: (item) => (item?.Comp_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน"),
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "6%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Comp_Code,
      item?.Comp_Name_TH,
      item?.Comp_Name_EN,
      item?.Comp_ShortName,
      item?.Comp_TaxNo,
      item?.Comp_Tel1,
      item?.Comp_Tel2,
      item?.Comp_Contact1,
      item?.Comp_Contact2,
      item?.Comp_Province,
      item?.Comp_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  const customHeader = (
    <div className="d-flex align-items-center" style={{ width: '100%', gap: 16, flexWrap: 'nowrap' }}>
      <label className="mb-0" style={{ fontWeight: 700, fontSize: 13, marginRight: 8, minWidth: 150, whiteSpace: 'nowrap' }}>สถานะการใช้งาน</label>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="compStatusFilter" id="filterCompActive" value="Y" checked={statusFilter === "Y"} onChange={() => setStatusFilter("Y")} />
          <span style={{ fontSize: 14 }}>ใช้งาน</span>
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="compStatusFilter" id="filterCompInactive" value="N" checked={statusFilter === "N"} onChange={() => setStatusFilter("N")} />
          <span style={{ fontSize: 14 }}>ไม่ใช้งาน</span>
        </label>
      </div>
    </div>
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/company"
      data={filteredMasterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      fieldMappings={{ no: "Comp_Id" }}
      getRowId={(item) => item?.Comp_Id}
      customHeader={customHeader}
    />
  );
};

export default CompanyMain;
